const swatchSelector = '.featured-products__swatch[data-variant-image]';

function navigateCarousel(button, direction) {
  const section = button.closest('.featured-products');
  const carousel = section?.querySelector('slideshow-component.featured-products__carousel');

  if (!carousel || typeof carousel[direction] !== 'function') return;

  carousel[direction]();
}

function selectSwatch(swatch) {
  const card = swatch.closest('.featured-products__card');
  const image = card?.querySelector('.featured-products__image');
  const media = card?.querySelector('.featured-products__media');

  if (!card || !image || !media) return;

  // Update product image
  image.src = swatch.dataset.variantImage;
  image.srcset = `${swatch.dataset.variantImageSmall} 400w, ${swatch.dataset.variantImage} 700w, ${swatch.dataset.variantImageLarge} 1000w`;
  image.alt = swatch.dataset.variantImageAlt;

  // Update product URL
  card.href = swatch.dataset.variantUrl;

  // Update selected swatch
  card.querySelectorAll(swatchSelector).forEach((item) => {
    item.setAttribute('aria-pressed', String(item === swatch));
  });

  // Update sold-out badge based on selected variant
  const isAvailable = swatch.dataset.variantAvailable === 'true';
  let badge = media.querySelector('.featured-products__badge');

  if (!isAvailable) {
    // Create badge if it doesn't already exist
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'featured-products__badge';
      badge.textContent = 'Sold out';
      media.appendChild(badge);
    }
  } else {
    // Remove badge when selected variant is available
    if (badge) {
      badge.remove();
    }
  }
}

document.addEventListener('click', (event) => {
  const previousButton = event.target.closest('[data-featured-products-previous]');
  if (previousButton) {
    navigateCarousel(previousButton, 'previous');
    return;
  }

  const nextButton = event.target.closest('[data-featured-products-next]');
  if (nextButton) {
    navigateCarousel(nextButton, 'next');
    return;
  }

  const swatch = event.target.closest(swatchSelector);
  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();
  selectSwatch(swatch);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const swatch = event.target.closest(swatchSelector);
  if (!swatch) return;

  event.preventDefault();
  selectSwatch(swatch);
});
